import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { EditLifeInsuranceForm } from "web_myplann/Portfolio/Pages/LifeInsuranceEdit/EditLifeInsuranceForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditLifeInsurancePage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.LifeInsurance}
			title={(portfolio) =>
				t(Resources.Portfolio.EditPortfolio.title, {
					type: getPortfolioTitle(portfolio, t),
				})
			}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditLifeInsuranceForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
